// extracted by mini-css-extract-plugin
export default {"section":"social-sections-ErrorSection__section--33WfM"};